import { Button, FormControl, TextField } from '@material-ui/core';
import styled from 'styled-components';
import imageCountry from '~/assets/Brazil.png';
import vrioCorp from '~/assets/VrioFaq.png';

interface Iprops {
  identificationkeyerror?: boolean;
  ownershiptypeerror?: boolean;
}

export const StyledButton = styled(Button)`
  background: linear-gradient(45deg, #135db4 30%, #1473e6 90%);
  padding: 7px 14px;
  border-radius: 24px !important;
  height: 40px;
  width: 120px;
  & .MuiButton-label {
    color: #fff;
  }
`;

export const StyledTextField = styled(TextField)<Iprops>`
  label.focused {
    background-color: #1535ff !important;
    padding: 14.5px 14px;
  }

  .MuiFormLabel-root {
    font-size: 14px;
    text-align: center;
  }

  .MuiFormLabel-root.Mui-focused {
    color: ${props =>
      props.identificationkeyerror
        ? '#c53030 !important'
        : '#1535ff !important'};
  }

  .MuiInputLabel-outlined {
    background-color: #fff !important;
    color: ${props => (props.identificationkeyerror ? '#c53030' : ' #a2a3a5')};

    padding: 2px 10px;
    margin-left: -5px;
  }

  .MuiOutlinedInput-root {
    font-size: 14px;

    fieldset {
      border-color: ${props =>
        props.identificationkeyerror ? '#c53030' : '#eaeaea'};
    }

    &:hover fieldset {
      border-color: ${props =>
        props.identificationkeyerror ? '#c53030' : '#eaeaea'};
      border-color: ${props => !!props.disabled && '#bdbdbd'};
    }

    &.Mui-focused fieldset {
      color: red;
      border-color: ${props =>
        props.identificationkeyerror
          ? '#c53030 !important'
          : '#1535ff !important'};
    }
  }
`;

export const FormControlLGPD = styled(FormControl)<Iprops>`
  width: 100%;

  label {
    color: ${props =>
      props.ownershiptypeerror ? '#c53030 !important' : '#000000de !important'};
  }

  .MuiInputBase-root {
    color: ${props =>
      props.ownershiptypeerror ? '#c53030 !important' : '#000000de !important'};

    &:hover .MuiOutlinedInput-notchedOutline {
      border-color: ${props =>
        props.ownershiptypeerror ? '#c53030' : '#eaeaea'};
    }

    svg {
      top: 20px;
      color: ${props =>
        props.ownershiptypeerror ? '#c53030 !important' : '#000000de'};
    }
    font-size: 14px;

    fieldset {
      border-color: ${props =>
        props.ownershiptypeerror ? '#c53030 !important' : '#eaeaea'};

      &:hover fieldset {
        border-color: ${props =>
          props.ownershiptypeerror ? '#c53030' : '#eaeaea'};
      }

      legend {
        border-bottom: 0;
        width: auto !important;
      }
    }

    &.Mui-focused fieldset {
      color: red;
      border-color: ${props =>
        props.ownershiptypeerror ? '#c53030 !important' : '#1535ff !important'};
    }
  }

  label.focused {
    background-color: #1535ff !important;
    padding: 14.5px 14px;
  }

  .MuiFormLabel-root {
    font-size: 14px;
    text-align: center;
    padding: 2px 10px;
    margin-left: -5px;
  }

  .MuiFormLabel-root.Mui-focused {
    color: ${props =>
      props.ownershiptypeerror ? '#c53030 !important' : '#1535ff !important'};
  }

  .MuiFormLabel-root.Mui-focused {
    color: ${props =>
      props.ownershiptypeerror ? '#c53030 !important' : '#000000de !important'};
  }

  .MuiInputLabel-outlined {
    color: ${props => (props.ownershiptypeerror ? '#c53030' : '#000000de')};
  }

  padding: 2px 10px;
  margin-left: -5px;

  .MuiSelect-select:not([multiple]) option,
  .MuiSelect-select:not([multiple]) optgroup {
    color: #222;
  }
`;

export const Container = styled.div`
  height: 100%;
  background-color: #000;
`;

export const ContentWrapper = styled.div`
  .fade-appear {
    opacity: 0;
    z-index: 1;
  }
  .fade-appear.fade-appear-active {
    opacity: 1;
    transition: opacity 1000ms linear;
  }

  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 1% 3%;

  .content {
    display: flex;
    height: 100vh;
    width: 100%;
    justify-content: space-between;

    .vrio-corp {
      padding-top: 80px;

      span {
        background-image: url(${props => props.theme.colors.logoVrio});
        background-repeat: no-repeat;
        width: 90px;
        height: 100%;
        text-indent: -5000em;
        display: inline-block;
        background-size: contain;
      }
    }

    .image-country {
      span {
        background-image: url(${imageCountry});
        background-repeat: no-repeat;
        background-position: center;
        width: 350px;
        height: 100%;
        text-indent: -5000em;
        display: inline-block;
        background-size: contain;
      }
    }

    .welcome {
      flex-direction: column;
      display: flex;
      justify-content: center;
      padding-right: 50px;

      h2 {
        color: #707070;
        font-size: 2.5em;
      }
      h1 {
        color: #fff;
        font-size: 3.5em;
      }
    }
  }
`;

export const WrapperTest = styled.div`
  position: relative;
  left: 60%;
  height: 600px;
  top: 50%;

  @media (max-width: 1260px) {
    display: flex;
    justify-content: center;
    height: 600px;
    width: 100%;
    position: inherit;
  }
`;

export const Wrapper = styled.div`
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 500px;
  min-width: 440px;
  width: 100%;
  background-color: #fff;
  border-radius: 6px;
  height: fit-content;

  .container-form {
    padding: 10px 60px;
    padding-top: 40px;
  }

  .content-small {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #222222;
    max-width: 500px;
    min-width: 440px;
    width: 100%;
    height: 90px;

    .vrio-corp {
      span {
        background-image: url(${vrioCorp});
        background-repeat: no-repeat;
        width: 90px;
        height: 100%;
        text-indent: -5000em;
        display: inline-block;
        background-size: contain;
        border-right: 1px solid #fff;
        margin-right: 40px;
      }
    }

    .image-country {
      span {
        background-image: url(${imageCountry});
        background-repeat: no-repeat;
        background-position: center;
        width: 300px;
        height: 300px;
        text-indent: -5000em;
        display: inline-block;
        background-size: contain;
      }
    }

    .welcome {
      flex-direction: column;
      display: flex;
      justify-content: center;

      h2 {
        color: #707070;
        font-size: 1.2em;
        margin: 0;
      }
      h1 {
        margin: 0;
        color: #fff;
        font-size: 1.7em;
      }
    }
  }

  .label-email {
    font-size: 1.2rem;
  }

  .header {
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;

    > img {
      height: 45px;
      object-fit: contain;
    }

    h1,
    h4 {
      color: #222222;
    }

    h1 {
      font-size: 36px;
      margin-bottom: 5px;
      margin-top: 10px;
    }

    h4 {
      font-size: 16px;
      font-weight: 500;
      margin-top: 0px;

      a {
        font-size: 16px;
        text-decoration: none;
      }
    }
  }

  .nav-options {
    border-top: 1px solid #eaeaea;
    padding: 25px 0;

    p {
      padding-bottom: 5px;
    }

    a {
      font-size: 1.4rem;
      text-decoration: none;
    }
  }

  p.footer {
    font-size: 1.1rem;
    color: #72757a;

    a {
      font-size: 1.1rem;
      text-decoration: none;
    }
  }

  form {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 25px;

    .MuiFormControl-root {
      margin-bottom: 20px;
    }

    .StyledButton-align {
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }

    p {
      font-size: 1.4rem;
      color: #72757a;
      margin-bottom: 5px;

      a {
        font-size: 1.4rem;
        text-decoration: none;
      }
    }

    .warning {
      font-size: 1.4rem;
      color: #c53030;
      margin-bottom: 5px;
    }

    .ReCAPTCHA {
      margin: 10px 0;
    }

    .button-continue {
      margin: 20px 0;
    }
  }

  .input-file-LGPD {
    min-height: 100%;

    .MuiDropzoneArea-textContainer {
      p {
        margin-bottom: 60px;
        padding: 0 15px;
      }

      svg {
        display: none;
      }
    }

    .MuiDropzonePreviewList-root {
      flex-direction: column;
      margin-bottom: 10px;

      .MuiDropzonePreviewList-imageContainer {
        width: 100%;
        max-width: 100%;
        padding: 5px 40px;

        &:hover {
          background: #22222208;
        }

        .MuiDropzonePreviewList-image {
          display: none;
        }

        .MuiTypography-body1 {
          text-align: left;
          width: 85%;
          margin: 15px 0;
        }

        .MuiDropzonePreviewList-removeButton {
          opacity: 1;
          right: 40px;
          top: 12%;
          background: no-repeat;
          box-shadow: none;
        }
      }
    }
  }

  @media (min-width: 1260px) {
    .content-small {
      display: none;
    }
  }

  @media (max-width: 768px) {
    margin: 0;
  }
`;
